
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipper/managed-transportation",
      function () {
        return require("private-next-pages/shipper/managed-transportation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipper/managed-transportation"])
      });
    }
  